import React, { useEffect, useState } from "react";
import Layout, { Container } from "../components/layout";
import { useUser } from "../config/userProvider";
import { apiurl } from "../config/config";
import { InfiLoader } from "../components/loader";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import BackHeader from "../components/backHeader";



const Tickets = () => {

  const navigate = useNavigate();

  const {
    userData,
  } = useUser();

  console.log("USERDATA IS :", userData.email)

  const [ticketData, setTicketData] = useState(null);
  const [loading, setLoading] = useState(false);
  // const [error, setError] = useState(null);

  console.log("ticketData", ticketData)

  const fetchTicketData = async (email) => {
    setLoading(true); // Start loading
    // setError(null); // Reset error

    try {
      const response = await axios.post(
        `${apiurl}/admin/v1/ticket/get`,
        { email },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.status === 200) {
        setTicketData(response?.data?.data); // Set the fetched ticket data
      } else {
        console.error('Failed to fetch ticket data:', response.status);
        // setError('Failed to fetch ticket data. Please try again.');
      }
    } catch (err) {
      console.error('Error fetching ticket data:', err);
      // setError('An error occurred. Please try again.');
    } finally {
      setLoading(false); // End loading
    }
  };

  useEffect(() => {
    if (userData?.email) {
      fetchTicketData(userData.email); // Call the function with the email
    }
  }, [userData?.email]); // Re-run only if the email changes


  const handleTicketDetails = (id) => {
    navigate(`/ticketdetails/${id}`);
  };

  return (
    <Layout>
      <Container>
        {loading === true ?
          <InfiLoader maintext="Fetching Ticket Data..." />
          :

          <section className="py-2 md:p-4  bg-gray-50 w-full h-full overflow-scroll overflow-hidden">
            {/* <div className="flex justify-between align-middle items-center px-4 py-0 py-4 ">
                <div className="flex text-sm text-black">
                  <p className="font-medium">Total : </p>
                  <p className="font-bold"> 1246 Assignees</p>
                </div>
                <div className="px-4 py-2 border bg-white border-gray-100 rounded-full flex">
                  <p className="text-sm">Filter</p>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13.9893 16.7151C12.4566 16.7151 11.0117 15.8849 10.2294 14.5419C9.81427 13.8582 9.59873 13.0605 9.59873 12.2384C9.59873 9.77209 11.5705 7.76163 13.9893 7.76163C16.4081 7.76163 18.3799 9.77209 18.3799 12.2384C18.3799 13.0605 18.1564 13.8582 17.7413 14.55C16.9669 15.8849 15.53 16.7151 13.9893 16.7151ZM13.9893 8.98256C12.2251 8.98256 10.7962 10.4395 10.7962 12.2384C10.7962 12.8326 10.9558 13.4105 11.2592 13.907C11.8339 14.8919 12.8797 15.4942 13.9893 15.4942C15.1229 15.4942 16.1447 14.9081 16.7194 13.9151C17.0228 13.4105 17.1825 12.8326 17.1825 12.2384C17.1825 10.4395 15.7535 8.98256 13.9893 8.98256Z"
                      fill="#ABBBC8"
                    />
                    <path
                      d="M15.4102 12.8325H12.5763C12.249 12.8325 11.9776 12.5558 11.9776 12.2221C11.9776 11.8884 12.249 11.6116 12.5763 11.6116H15.4102C15.7375 11.6116 16.009 11.8884 16.009 12.2221C16.009 12.5558 15.7375 12.8325 15.4102 12.8325Z"
                      fill="#ABBBC8"
                    />
                    <path
                      d="M13.9893 14.3058C13.662 14.3058 13.3906 14.0291 13.3906 13.6953V10.814C13.3906 10.4802 13.662 10.2035 13.9893 10.2035C14.3166 10.2035 14.588 10.4802 14.588 10.814V13.7035C14.588 14.0372 14.3246 14.3058 13.9893 14.3058Z"
                      fill="#ABBBC8"
                    />
                    <path
                      d="M9.23944 18.75C8.85627 18.75 8.47309 18.6523 8.12983 18.457C7.41935 18.05 6.99626 17.3174 6.99626 16.4953V12.1407C6.99626 11.7337 6.73283 11.1151 6.47737 10.7977L3.44388 7.54999C2.94096 7.02092 2.5498 6.13373 2.5498 5.48257V3.58604C2.5498 2.27558 3.52371 1.25 4.76106 1.25H15.4102C16.6316 1.25 17.6214 2.25932 17.6214 3.50467V5.31162C17.6214 6.16627 17.1265 7.12677 16.6475 7.63142L15.2106 8.92558C15.0669 9.05581 14.8674 9.10463 14.6758 9.06393C14.4602 9.00696 14.2288 8.98256 13.9893 8.98256C12.2251 8.98256 10.7962 10.4395 10.7962 12.2384C10.7962 12.8326 10.9558 13.4105 11.2591 13.9151C11.5146 14.3465 11.8578 14.7047 12.257 14.957C12.4326 15.071 12.5443 15.2663 12.5443 15.4779V15.7547C12.5443 16.3977 12.1612 17.3012 11.5225 17.6837L10.4209 18.4082C10.0617 18.6361 9.64657 18.75 9.23944 18.75ZM4.76904 2.47093C4.20226 2.47093 3.75522 2.9593 3.75522 3.58604V5.48257C3.75522 5.77559 3.9947 6.37792 4.31402 6.7035L7.38742 10C7.79455 10.5128 8.20167 11.3837 8.20167 12.1488V16.5035C8.20167 17.0407 8.56888 17.3093 8.72056 17.3989C9.06382 17.5942 9.47095 17.5861 9.78228 17.3907L10.8999 16.6581C11.1154 16.5279 11.331 16.1128 11.3469 15.8198C10.9079 15.4861 10.5247 15.0546 10.2373 14.5663C9.82219 13.8744 9.59867 13.0768 9.59867 12.2628C9.59867 9.79654 11.5704 7.78607 13.9892 7.78607C14.2128 7.78607 14.4363 7.80235 14.6438 7.83491L15.8253 6.76863C16.0967 6.48374 16.432 5.80815 16.432 5.32791V3.52091C16.432 2.95114 15.977 2.48723 15.4182 2.48723H4.76904V2.47093Z"
                      fill="#ABBBC8"
                    />
                  </svg>
                </div>
              </div> */}


            <div className="mb-8">
              <BackHeader
                backButton={true}
                link="/support"
                title="Tickets"
              />
            </div>

            {ticketData && ticketData.length === 0 ?
              <div className="flex flex-col items-center justify-center h-full w-full rounded-lg bg-gray-50">
                <div className="flex flex-col items-center bg-white border border-gray-200 rounded-lg shadow-md p-8 max-w-sm">
                  <img
                    src="/noTickets.png"
                    alt="No Tickets"
                    className="w-36 h-36 mb-4"
                  />
                  <h2 className="text-xl font-semibold text-gray-800 mb-2">No Tickets Found</h2>
                  <p className="text-gray-600 text-center">
                    It seems you haven't any complaints yet.
                  </p>

                </div>
              </div>
              :

              <div className="grid grid-cols-1 gap-4 px-4 mt-8 sm:grid-cols-2 lg:grid-cols-3 ">
                {ticketData &&
                  ticketData.map((ticket) => (
                    <div
                      key={ticket._id}
                      className="p-4 bg-white border border-gray-200 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200"
                    >
                      <p
                        className="text-sm flex justify-end cursor-pointer"
                        onClick={() => handleTicketDetails(ticket._id)}
                      >
                        <span className="px-3 py-1 rounded-full text-sm text-emerald-700 bg-emerald-100">
                          Open
                        </span>
                      </p>
                      <div className="flex items-center my-2">
                        <div className="px-2">
                          {/* SVG Icon */}
                          <svg
                            width="40"
                            height="40"
                            viewBox="0 0 40 40"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clipPath="url(#clip0_3308_372)">
                              <rect width="40" height="40" rx="12" fill="#EBF9F5" />
                              <path
                                d="M20.6778 27.957C20.9525 28.021 20.9777 28.3808 20.7101 28.47L19.1301 28.99C15.1601 30.27 13.0701 29.2 11.7801 25.23L10.5001 21.28C9.2201 17.31 10.2801 15.21 14.2501 13.93L14.7741 13.7565C15.177 13.6231 15.569 14.0271 15.4546 14.4358C15.3979 14.6384 15.3434 14.8498 15.2901 15.07L14.3101 19.26C13.2101 23.97 14.8201 26.57 19.5301 27.69L20.6778 27.957Z"
                                fill="#45C49C"
                              />
                              <path
                                d="M25.1701 11.21L23.5001 10.82C20.1601 10.03 18.1701 10.68 17.0001 13.1C16.7001 13.71 16.4601 14.45 16.2601 15.3L15.2801 19.49C14.3001 23.67 15.5901 25.73 19.7601 26.72L21.4401 27.12C22.0201 27.26 22.5601 27.35 23.0601 27.39C26.1801 27.69 27.8401 26.23 28.6801 22.62L29.6601 18.44C30.6401 14.26 29.3601 12.19 25.1701 11.21ZM23.2901 21.33C23.2001 21.67 22.9001 21.89 22.5601 21.89C22.5001 21.89 22.4401 21.88 22.3701 21.87L19.4601 21.13C19.0601 21.03 18.8201 20.62 18.9201 20.22C19.0201 19.82 19.4301 19.58 19.8301 19.68L22.7401 20.42C23.1501 20.52 23.3901 20.93 23.2901 21.33ZM26.2201 17.95C26.1301 18.29 25.8301 18.51 25.4901 18.51C25.4301 18.51 25.3701 18.5 25.3001 18.49L20.4501 17.26C20.0501 17.16 19.8101 16.75 19.9101 16.35C20.0101 15.95 20.4201 15.71 20.8201 15.81L25.6701 17.04C26.0801 17.13 26.3201 17.54 26.2201 17.95Z"
                                fill="#45C49C"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_3308_372">
                                <rect width="40" height="40" rx="12" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </div>
                        <p className="text-base font-bold text-black">{ticket.subcategory}</p>
                      </div>
                      <hr />
                      <div className="grid grid-cols-2 gap-4 mt-4">
                        <div className="col-span-2">
                          <h4 className="text-gray-500 text-sm">User</h4>
                          <p className="text-black text-sm font-bold">{ticket.firstname}{" "}{ticket.lastname}</p>
                        </div>
                        <div>
                          <h4 className="text-gray-500 text-sm">Submitted</h4>
                          <p className="text-black text-sm font-bold">
                            {new Date(ticket.createdAt).toLocaleDateString()}
                          </p>
                        </div>
                        <div>
                          <h4 className="text-gray-500 text-sm">Priority</h4>
                          <p className="text-black text-sm font-bold">{ticket.priority}</p>
                        </div>
                        <div>
                          <h4 className="text-gray-500 text-sm">Ticket ID</h4>
                          <p className="text-black text-sm font-bold">{ticket.id}</p>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            }


          </section>}
      </Container>
    </Layout>
  );
};

export default Tickets;
